exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media(min-width: 2560px){\n\n.greeting{\n  padding-top: 15vh !important;\n  font-size: 10em !important;\n}\n\n}", ""]);

